export default __webpack_public_path__ + "static/media/zombie_death.7bad6105.mp3";